<template>
  <div class="home">
    <!-- Header -->
    <div class="container p-0" id="top">
      <img src="@/assets/img/header-preview.png" alt="header" width="100%" />
    </div>
    <!-- Header -->
    <!-- Body -->
    <div class="container">
      <div class="row bg_ffffff">
        <div class="col-12 col-sm-12 padding_30 padding_top_20">
          <div class="csfont_Signika_Lite color_6d6e71 text-left font-size-16">
            <form @submit.prevent="saveData()">
              <div class="row px-3">
                <div class="col-12 col-sm-12 mt-4">
                  <h4 class="text-dark mb-0">แนบหลักฐานเพื่อประกอบการพิจารณาเอกสาร</h4>
                  <small class="text-dark fs-5">(หากเอกสารไม่ครบจะไม่รับพิจารณา)</small>
                  <ol class="text-dark pb-4 pt-4">
                    <li>
                      <div class="mb-5 row">
                        <span class="col-12 mb-2">
                          สำเนาบัตรประชาชน และทะเบียนบ้าน ของนักศึกษา จำนวน 1 ชุด
                        </span>
                        <div class="col-12">
                          <label class="custom-file-upload btn btn-app" for="cardStudent">
                            อัปโหลด
                          </label>
                          <input
                            id="cardStudent"
                            type="file"
                            @change="FileUploadStudent"
                            accept="application/pdf,image/*"
                          />
                          <span class="pl-2">{{ FileData.fileCardStudent.name }}</span>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="mb-5 row">
                        <span class="col-12 mb-2">
                          สำเนาบัตรประชาชนของ บิดา หรือ มารดา หรือผู้ปกครอง จำนวน 1 ชุด
                        </span>
                        <div class="col-12">
                          <label class="custom-file-upload btn btn-app" for="cardFamily">
                            อัปโหลด
                          </label>
                          <input
                            id="cardFamily"
                            type="file"
                            @change="FileUploadFamily"
                            accept="application/pdf,image/*"
                          />
                          <span class="pl-2">{{ FileData.fileCardFamily.name }}</span>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="mb-5 row">
                        <span class="col-12 mb-2">
                          สำเนาแสดงผลการเรียนชั้นปีปัจจุบัน จำนวน 1 ชุด
                        </span>
                        <div class="col-12">
                          <label class="custom-file-upload btn btn-app" for="GPAStudent">
                            อัปโหลด
                          </label>
                          <input
                            id="GPAStudent"
                            type="file"
                            @change="FileUploadGPA"
                            accept="application/pdf,image/*"
                          />
                          <span class="pl-2">{{ FileData.fileCardGPA.name }}</span>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="mb-5 row">
                        <span class="col-12 mb-2">
                          หนังสือรับรองของอาจารย์ที่ปรึกษา
                          <span class="text-success fw-bold">✓</span>
                        </span>
                      </div>
                    </li>
                    <li>
                      <div class="mb-5 row">
                        <span class="col-12 mb-2">
                          สำเนาบัตรประจำตำแหน่งผู้รับรองรายได้
                        </span>
                        <div class="col-12">
                          <label class="custom-file-upload btn btn-app" for="cardApprove">
                            อัปโหลด
                          </label>
                          <input
                            id="cardApprove"
                            type="file"
                            @change="FileUploadApprove"
                            accept="application/pdf,image/*"
                          />
                          <span class="pl-2">{{ FileData.fileCardApproved.name }}</span>
                        </div>
                      </div>
                    </li>
                  </ol>
                  <center>
                    <button class="btn btn-app align-center mx-1 p-tb-4 mt-1">
                      <span v-if="!loadding"> ส่งเอกสาร </span>
                      <div class="pd-btn" v-else>
                        <div class="spinner-border text-light" role="status">
                          <span class="visually-hidden"></span>
                        </div>
                      </div>
                    </button>
                  </center>
                  <div class="child-1"><br /><br /></div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- Footer -->
    <div class="container p-0">
      <img src="@/assets/img/footer.png" alt="header" width="100%" />
    </div>
    <!-- Footer -->
    <div class="child-1"><br /><br /></div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "MembershipApplicationCpfPreviewMode",

  data() {
    return {
      loadding: false,
      FileList: {
        fileCardStudent: null,
        fileCardFamily: null,
        fileCardGPA: null,
        fileCardApproved: null,
      },
      FileData: {
        fileCardStudent: { name: null },
        fileCardFamily: { name: null },
        fileCardGPA: { name: null },
        fileCardApproved: { name: null },
      },
      RandomID: null,
      // BaseURLData: "http://localhost:8085/form/scholarship/",
      // BaseAPIData: "http://localhost:8083/",

      BaseURLData: "https://tica.or.th/uploads/form/scholarship-cpf/",
      BaseAPIData: "https://tica.or.th/uploads/form/scholarship-cpf/images/save/",
    };
  },
  async created() {
    this.RandomID = await sessionStorage.getItem("UID");
  },
  mounted() {},

  methods: {
    ViewScholarship() {
      this.$emit("ViewScholarship");
    },
    EditScholarship() {
      this.$emit("EditScholarship");
    },
    ViewIncome() {
      this.$emit("ViewIncome");
    },
    EditIncome() {
      this.$emit("EditIncome");
    },
    ViewAdvisor() {
      this.$emit("ViewAdvisor");
    },
    EditAdvisor() {
      this.$emit("EditAdvisor");
    },
    async saveData() {
      this.loadding = true;
      this.FileList.fileCardStudent = await this.UploadFile(
        this.FileData.fileCardStudent,
        "profile",
        "studentCard"
      );
      this.FileList.fileCardFamily = await this.UploadFile(
        this.FileData.fileCardFamily,
        "profile",
        "familyCard"
      );
      this.FileList.fileCardGPA = await this.UploadFile(
        this.FileData.fileCardGPA,
        "profile",
        "gpa"
      );
      this.FileList.fileCardApproved = await this.UploadFile(
        this.FileData.fileCardApproved,
        "profile",
        "approvedCard"
      );
      await this.SetSession();
      await this.insertData();
      await this.goCreatePDF();
    },
    async SetSession() {
      await sessionStorage.setItem("fileList", JSON.stringify(this.FileList));
    },
    async insertData() {
      const BaseAPIData = this.BaseAPIData;
      const UID = this.RandomID;
      const dataI1 = sessionStorage.getItem("dataI1");
      const dataI2 = sessionStorage.getItem("dataI2");
      const dataI3 = sessionStorage.getItem("dataI3");
      const fileList = JSON.stringify(this.FileList);
      var logURL = `${BaseAPIData}insertData.php`;
      var header = { headers: { "Content-Type": "multipart/form-data" } };
      // insert data
      const data = new FormData();
      data.append("DataI1", dataI1);
      data.append("DataI2", dataI2);
      data.append("DataI3", dataI3);
      data.append("DataID", UID);
      data.append("fileList", fileList);
      await axios.post(logURL, data, header).then((response) => {
        return true;
      });
    },
    async UploadFile(fileData, folder, Name) {
      var FileName = "";
      const UID = this.RandomID;
      const BaseURLData = this.BaseURLData;
      const BaseAPIData = this.BaseAPIData;
      this.loadding = true;
      const data = new FormData();
      data.append("fileUpload", fileData);
      data.append("fileName", Name);
      data.append("target", UID);
      data.append("subtarget", folder);
      const url = `${BaseAPIData}uploadFileDetail.php`;
      const header = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      await axios.post(url, data, header).then(function (response) {
        FileName = `${BaseURLData}images/save/assets/img/${UID}/${folder}/${response.data.response}.${response.data.type}`;
      });
      return FileName;
    },
    FileUploadStudent(evt) {
      evt.preventDefault();
      this.FileData.fileCardStudent = evt.target.files[0];
    },
    FileUploadFamily(evt) {
      evt.preventDefault();
      this.FileData.fileCardFamily = evt.target.files[0];
    },
    FileUploadGPA(evt) {
      evt.preventDefault();
      this.FileData.fileCardGPA = evt.target.files[0];
    },
    FileUploadApprove(evt) {
      evt.preventDefault();
      this.FileData.fileCardApproved = evt.target.files[0];
    },
    goCreatePDF() {
      this.$router.push("process");
    },
  },
};
</script>

<style scoped>
.w-100 {
  width: 100% !important;
}
.bg_dark_blue {
  background-color: #102f50 !important;
}
.text-secondary {
  border-top: 1px solid #bfc6cc !important;
}
.catgory-input {
  position: absolute !important;
  right: 0 !important;
  padding-right: 5% !important;
}
.home {
  background-color: #3c3c3b !important;
  font-family: Georgia, Times, serif !important;
}
input[type="file"] {
  display: none !important;
}
.custom-file-upload {
  border: 1px solid #ccc !important;
  display: inline !important;
  padding: 5px 12px !important;
  cursor: pointer !important;
  white-space: normal !important;
}

.custom-exam-upload {
  border: 1px solid #ccc !important;
  display: inline !important;
  padding: 5px 12px !important;
  cursor: pointer !important;
  white-space: normal !important;
}
.btn-app {
  color: #fff !important;
  background-color: #102f51 !important;
}
.btn-app:hover {
  color: #fff !important;
  background-color: #235a99 !important;
}
.text-truncate {
  white-space: nowrap !important;
  padding-right: 5rem !important;
  padding-left: 1rem !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.w-45 {
  width: 45%;
}
.other-btn {
  padding: 6px 25px !important;
}
</style>
<style>
.multiselect__option--highlight {
  background: #102f51 !important;
  outline: none !important;
  color: #fff !important;
}
.multiselect__option--highlight:after {
  background: #102f51 !important;
}
.multiselect__tag {
  position: relative;
  display: inline-block;
  padding: 4px 26px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #102f51;
  margin-bottom: 0;
}
.multiselect__tags {
  min-height: 25px;
  padding: 2px 40px 0 8px;
  border-color: black;
}
.multiselect__tag-icon:after {
  color: white;
}
.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: #102f51 !important;
}
.req {
  border-color: red !important;
}

.img-cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.p-tb-4 {
  padding-top: 3px;
  padding-bottom: 3px;
}
.child-1 {
  padding-bottom: 5rem;
}
.child-2 {
  padding-bottom: 10rem;
}
.spinner-border {
  width: 1rem;
  height: 1rem;
}
.pd-btn {
  padding-left: 30px;
  padding-right: 30px;
}
</style>
